import "./components/cart-upsell-collection";

import { pushCartDataLayer } from "./components/g-utils";

window.addEventListener('load', () => pushCartDataLayer());